<template>
    <b-container>
      <b-row>
        <h1>Semanteer - a comprehensive search platform</h1>
      </b-row>

      <div v-if="!services">
        <b-row>
          <b-card
            style="max-width: 20rem; min-width: 20rem;"
            class="mb-2 search-widget">
            Could not load service cards
          </b-card>
        </b-row>
      </div>
      <div v-else>
        <b-row>
          <b-card
              v-for="(service,idx) in services"
              :title="service.title"
              style="max-width: 20rem; min-width: 20rem;"
              class="mb-2 search-widget"
              :key="idx"
              >

              <p class="card-text" v-if="service.description">
              {{service.description}}
              </p>

              <div slot="footer" v-if="service.url">
                <span v-if="service.healthUrl">
                  <b-badge v-if="service.healthStatus" variant="success">Running</b-badge>
                  <b-badge v-if="service.healthStatus == false" variant="danger">Down</b-badge>
                </span>
                <b-button :href="service.url" target="_blank" variant="primary" class="float-right">Open</b-button>

              </div>
          </b-card>
        </b-row>
        <b-row>
          <b-button v-on:click="refresh" variant="primary" class="mt-3">
            <font-awesome-icon icon="undo" />
          </b-button>
        </b-row>
      </div>
    </b-container>
</template>

<script>
export default {
  name: 'home',
  created: function () {
    this.$store.dispatch('initializeServices')
  },
  computed: {
    services () {
      if (this.$store.state.services && this.$store.state.services.length > 0) {
        return this.$store.state.services.filter((s) => {
          return s.installed === true
        })
      } else {
        return null
      }
    }
  },
  methods: {
    refresh () {
      this.$store.dispatch('refreshServices')
    }
  }
}
</script>

<style>
  .search-widget {
    margin-right: 20px;
    margin-top: 10px;
  }
</style>
